import script from "./YouAndThem.vue?vue&type=script&setup=true&lang=js"
export * from "./YouAndThem.vue?vue&type=script&setup=true&lang=js"

import "./YouAndThem.vue?vue&type=style&index=0&id=9408dd70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9408dd70"]])

export default __exports__